module.exports = __webpack_public_path__ + "static/img/tdf-logo2.724d36e.png";